<template lang="pug">
div.tos
  //- div(v-if="$i18n.locale === 'en'")
  GDPREn
  //- div(v-else)
    GDPRZh
  Separator(class="my-4")
  span {{$t('last-revision')}} 13/05/2021
</template>

<script setup>
import { Separator } from '@/components/ui/separator'
import GDPRZh from '~/components/dif-lang/GDPRZh'
import GDPREn from '~/components/dif-lang/GDPREn'
</script>

<style lang="postcss">
.tos {
  text-align: left;
  max-width: var(--secondary-max-width);
  padding: 0 1rem 3rem;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  h1,
  h2,
  h3 {
    line-height: 1.25;
    margin-top: 3rem;
    font-weight: 500;
  }

  h1 {
    font-size: 2.5rem;
    font-weight: 600;
  }

  summary {
    display: list-item;
  }

  color: var(--secondary-color);
  font-family: Rubik,
  -apple-system,
  BlinkMacSystemFont,
  Segoe UI,
  Helvetica,
  Arial,
  sans-serif,
  Apple Color Emoji,
  Segoe UI Emoji,
  Segoe UI Symbol;
  font-size: 1rem;
  line-height: 2;
  /* ul {
    padding-left: 1.5rem;
  } */
}</style>
